// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react'
import { ModalProps } from './types'
import StyledModal from 'styled-react-modal'
import * as S from './styles'
import { ModalHeader } from './components/ModalHeader'
import { ModalContent } from './components/ModalContent'
import { ModalFooter } from './components/ModalFooter'

export const Modal = ({
  isOpen,
  closeModal,
  modalHeader,
  children,
  onBackgroundClick,
  classNameForModalWrapper,
  classNameForModalHeader,
  classNameForModalContent,
  classNameForModalFooter,
  hideHeaderCloseButton,
  modalFooterChildren,
  onEscapeKeydown,
  backgroundProps,
  borderRadius
}: ModalProps) => {
  return (
    <StyledModal
      backgroundProps={backgroundProps}
      isOpen={isOpen}
      onBackgroundClick={onBackgroundClick || closeModal}
      onEscapeKeydown={onEscapeKeydown || closeModal}
    >
      <S.Wrapper className={classNameForModalWrapper} $borderRadius={borderRadius}>
        {modalHeader && (
          <ModalHeader
            hideCloseButton={hideHeaderCloseButton}
            className={classNameForModalHeader}
            modalHeader={modalHeader}
            closeModal={closeModal}
          />
        )}

        <ModalContent className={classNameForModalContent}>{children}</ModalContent>

        {modalFooterChildren && <ModalFooter className={classNameForModalFooter}>{modalFooterChildren}</ModalFooter>}
      </S.Wrapper>
    </StyledModal>
  )
}
